import { createFileRoute, Outlet } from '@tanstack/react-router'
import { BarChart2, CalendarDays, Home, User, Users } from 'lucide-react'
import { TabBar, type TabItem } from '@/components/app/tab-bar'
import { requireSpace } from '@/lib/guards'
import { canManageMembers, canViewFinance } from '@/lib/roles'

export const Route = createFileRoute('/_staff')({
  beforeLoad: () => requireSpace('/accueil'),
  component: StaffLayout,
})

/**
 * Les onglets sont filtrés selon les décorateurs @Roles du back-end : un
 * trésorier n'a pas accès à `GET /members`, l'onglet Membres ne doit donc pas
 * lui être proposé (il ne verrait qu'un 403).
 */
function StaffLayout() {
  const { roles } = Route.useRouteContext()

  const tabs: TabItem[] = [
    { to: '/accueil', label: 'Accueil', icon: Home },
    { to: '/cultes', label: 'Cultes', icon: CalendarDays },
    ...(canManageMembers(roles) ? [{ to: '/membres', label: 'Membres', icon: Users }] : []),
    ...(canViewFinance(roles) ? [{ to: '/finances', label: 'Finances', icon: BarChart2 }] : []),
    { to: '/profil', label: 'Profil', icon: User },
  ]

  return (
    <>
      <Outlet />
      <TabBar items={tabs} />
    </>
  )
}
